export default __webpack_public_path__ + "static/media/weezcrew-no-icon.3fce02fe.png";